import { AbTestDTO } from 'features/ab-tests/api/types/AbTestDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'

import type { Data, Variables } from './types'

type Props = {
  withYp2395?: boolean
}

export const GET_AB_TEST = ({ withYp2395 }: Props): TypedDocumentNode<Data, Variables> => gql`
  query getAbTest($id: ID!) {
    node(id: $id) {
      ... on AbTest {
        ${permitFields<AbTestDTO>({
          cookieLifetime: withYp2395,
          trafficSplitType: withYp2395,
        })}

        domain {
          activeAbTest {
            id
          }
          id
          name
        }
        variants
        id
        name
        status
        usedVariantsData {
          name
          reportedKeyValue
        }
      }
    }
  }
`
